import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import HomePageStyle from './home-page.module.scss';

const HeroContent = () => (
  <StaticQuery
    query={graphql`
      query HomepageHero {
        contentfulFsdHompage {
          homepageReference {
            hero {
              shortTitle
              headline {
                headline
              }
              paragraph {
                json
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={HomePageStyle.heroContentDiv}>
        <p className={HomePageStyle.heroIntro}>
          {data.contentfulFsdHompage.homepageReference.hero.shortTitle}
        </p>
        <h1 className={HomePageStyle.heroTitle}>
          {data.contentfulFsdHompage.homepageReference.hero.headline.headline}
        </h1>
        <div className={HomePageStyle.heroDescription}>
          {documentToReactComponents(
            data.contentfulFsdHompage.homepageReference.hero.paragraph.json
          )}
        </div>
        <a
          href='https://app.firststringdigital.com/starter-monthly'
          className='home-hero-btn'
        >
          Start My Free Trial
        </a>
      </div>
    )}
  />
);

export default HeroContent;
